<template>
    <Top />
    <!-- Spinner Start -->
    <!-- Spinner Start -->
    <div id="spinner" style="background-color: #DCDCDC;z-index: 999999;opacity: 0.5;" v-if="halamanloading"
        class="show position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <img src="../../../../src/assets/images/logo.png" height="40">&nbsp;
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
        </div>
        &nbsp;<span class="sr-only text-danger" style="font-weight: bolder;">..CISP System Loading...</span>
    </div>
    <!-- Spinner End -->
    <section class="hero-section d-flex justify-content-center align-items-center" id="section_1"
        :style="'background-image:url(' + folder_slider + foto_background + ') !important;'">
        <div class="section-overlay"></div>
        <svg xmlns="" viewBox="0 5 1440 320">
            <rect x="0" y="0" width="2980" height="100" fill="#3D405B" />
        </svg>
        <div class="container">
            <div class="row">
                <div class="col-lg-12 col-12 mb-5 mb-lg-0">
                    <h5 class="text-white">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">{{ namaku }}&nbsp;</span>
                        <span v-else>{{ nama_eng }}&nbsp;</span>
                    </h5>
                    <h1 class="cd-headline rotate-1 text-white mb-4 pb-2">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">{{ text_label }}&nbsp;</span>
                        <span v-else>{{ text_label_eng }}&nbsp;</span>
                        <span v-if="(bahasa === null) || (bahasa == 'ina')" class="cd-words-wrapper">
                            <template v-for="(dataketerangan, urutketerangan) in keterangan" :key="urutketerangan">
                                <b :class="[((urutketerangan == 0) ? 'is-visible' : '')]">{{ dataketerangan.nama }}</b>
                            </template>
                        </span>
                        <span v-else class="cd-words-wrapper">
                            <template v-for="(dataketerangan_eng, urutketerangan_eng) in keterangan_eng"
                                :key="urutketerangan_eng">
                                <b :class="[((urutketerangan_eng == 0) ? 'is-visible' : '')]">{{ dataketerangan_eng.nama
                                }}</b>
                            </template>
                        </span>
                    </h1>
                </div>
            </div>
        </div>

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path fill="#ffffff" fill-opacity="1"
                d="M0,224L34.3,192C68.6,160,137,96,206,90.7C274.3,85,343,139,411,144C480,149,549,107,617,122.7C685.7,139,754,213,823,240C891.4,267,960,245,1029,224C1097.1,203,1166,181,1234,160C1302.9,139,1371,117,1406,106.7L1440,96L1440,320L1405.7,320C1371.4,320,1303,320,1234,320C1165.7,320,1097,320,1029,320C960,320,891,320,823,320C754.3,320,686,320,617,320C548.6,320,480,320,411,320C342.9,320,274,320,206,320C137.1,320,69,320,34,320L0,320Z">
            </path>
        </svg>
    </section>
    <section class="about-section">&nbsp;</section>
    <section class="about-section">
        <div class="container">
            <div class="section-bg-image-block" style="border: solid 1px #D3D3D3;">
                <div class="row" style="padding-top: 10px;">
                    <div class="col-lg-12 col-12 me-auto mb-4 mb-lg-0">
                        <p class="text-justify">
                        <div class="help-block text-center wow fadeInLeft">
                            <h5 v-if="(bahasa === null) || (bahasa == 'ina')">
                                Silahkan pilih layanan. Mohon mengisi formulir dengan lengkap dan sejelas-jelasnya agar
                                admin dapat
                                menindaklanjuti layanan yang disampaikan.<br><br>
                            </h5>
                            <h5 v-else>
                                Please select a service. Please fill in the form completely and as clearly as possible
                                so
                                that the admin
                                can follow up on the service submitted.<br><br>
                            </h5>
                        </div>
                        <div class="col-sm-12">&nbsp;</div>
                        <ul class="nav nav-tabs justify-content-center" id="custom-tabs-four-tab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" id="custom-tabs-four-home-tab" data-toggle="pill"
                                    href="#custom-tabs-four-home" role="tab" aria-controls="custom-tabs-four-home"
                                    aria-selected="true">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Pengaduan</span>
                                    <span v-else>Complaint</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="custom-tabs-four-profile-tab" data-toggle="pill"
                                    href="#custom-tabs-four-profile" role="tab" aria-controls="custom-tabs-four-profile"
                                    aria-selected="false">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Permintaan Data Dan Informasi</span>
                                    <span v-else>Data and Information Requests</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="custom-tabs-four-risk-tab" data-toggle="pill"
                                    href="#custom-tabs-four-risk" role="tab" aria-controls="custom-tabs-four-risk"
                                    aria-selected="false">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Aspirasi Dan Masukan</span>
                                    <span v-else>Aspirations and Input</span>
                                </a>
                            </li>
                        </ul>
                        <div class="tab-content" id="custom-tabs-four-tabContent">
                            <div class="tab-pane fade show active" id="custom-tabs-four-home" role="tabpanel"
                                aria-labelledby="custom-tabs-four-home-tab">
                                <div class="row">
                                    <div class="col-sm-12 float-left pb-2 wow fadeInDown">&nbsp;</div>
                                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Kategori Aduan <small
                                                class="text-primary">
                                                (*wajib
                                                dipilih)</small></label>
                                        <label v-else>Complaint Type <small class="text-primary">
                                                (*must be selected)</small></label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i class="fas fa-marker"></i></span>
                                            </div>
                                            <v-select :options="masteraduan" :reduce="(label) => label.code"
                                                label="label" v-model="defaultSelectedmasteraduan"
                                                @update:modelValue="onmasteraduanChange"
                                                style="background-color: #ffffff;width: 93%;"></v-select>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Lokasi <small
                                                class="text-primary">
                                                (*wajib dipilih)</small></label>
                                        <label v-else>Location <small class="text-primary">
                                                (*must be selected)</small></label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i class="fas fa-map-marker"></i></span>
                                            </div>
                                            <v-select :options="lokasi" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedlokasi" @update:modelValue="onlokasiChange"
                                                style="background-color: #ffffff;color: black;width: 93%;"></v-select>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Nama </label>
                                        <label v-else>Name </label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i class="fas fa-user-circle"></i></span>
                                            </div>
                                            <input type="text" class="form-control form-control-sm" id="nama"
                                                name="nama" placeholder="Nama / Name" v-model="nama">
                                        </div>
                                    </div>
                                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Nomor Telepon </label>
                                        <label v-else>Phone number </label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i class="fas fa-phone"></i></span>
                                            </div>
                                            <input type="text" class="form-control form-control-sm" id="nohp"
                                                name="nohp" placeholder="Nomor Telepon / Phone number" v-model="nohp">
                                        </div>
                                    </div>
                                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Alamat email</label>
                                        <label v-else>Email Address</label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i class="fas fa-mail-bulk"></i></span>
                                            </div>
                                            <input type="text" class="form-control form-control-sm" id="alamat"
                                                name="alamat" placeholder="Alamat email / Email Address"
                                                v-model="alamat">
                                        </div>
                                    </div>
                                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Judul Aduan</label>
                                        <label v-else>Complaint Title</label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i
                                                        class="far fa-address-card"></i></span>
                                            </div>
                                            <input type="text" class="form-control form-control-sm" id="judul"
                                                name="judul" placeholder="Judul Aduan / Complaint Title"
                                                v-model="judul">
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Isi Aduan <small
                                                class="text-primary"> (*wajib
                                                diisi)</small></label>
                                        <label v-else>Complaint Contents<small class="text-primary">
                                                (*required)</small></label>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <quill-editor v-model:value="aduan" :options="modulenya"
                                                    style="height: 25vh;background-color: #ffffff;"></quill-editor>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 float-left pb-2 wow fadeInDown">&nbsp;</div>
                                    <div class="col-sm-6" style="display: none;">
                                        <label>Latitude <small class="text-primary"> (*wajib
                                                diisi)</small></label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i
                                                        class="fab fa-creative-commons-share"></i></span>
                                            </div>
                                            <input type="number" class="form-control form-control-sm" id="latitude"
                                                name="latitude" placeholder="Latitude Prasarana" v-model="latitude"
                                                readonly>
                                        </div>
                                    </div>
                                    <div class="col-sm-6" style="display: none;">
                                        <label>Longitude <small class="text-primary"> (*wajib
                                                diisi)</small></label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i
                                                        class="fab fa-creative-commons-share"></i></span>
                                            </div>
                                            <input type="number" class="form-control form-control-sm" id="longitude"
                                                name="longitude" placeholder="Longitude Prasarana" v-model="longitude"
                                                readonly>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 wow fadeInDown">
                                        <div class="card card-info collapsed-card">
                                            <div class="card-header border-transparent" data-card-widget="collapse"
                                                style="cursor: pointer;">
                                                <label v-if="(bahasa === null) || (bahasa == 'ina')"><i
                                                        class="fas fa-link"></i> Unggah
                                                    Lampiran</label>
                                                <label v-else><i class="fas fa-link"></i> Upload Attachments</label>
                                                <div class="card-tools">
                                                    <button type="button" class="btn btn-tool"
                                                        data-card-widget="collapse">
                                                        <i class="fas fa-plus"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="card-body px-3">
                                                <div class="row">
                                                    <!--IKON PETA 1-->
                                                    <div class="col-sm-12">
                                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">1. Foto
                                                            (images
                                                            files)</label>
                                                        <label v-else>1. Photo (images files)</label>
                                                        <div class="input-group mb-3">
                                                            <div class="input-group-prepend">
                                                                <span class="input-group-text"><i
                                                                        class="far fa-file-image"></i></span>
                                                            </div>
                                                            <input type="file" class="form-control form-control-sm"
                                                                id="fileToUploadfilenya_images"
                                                                name="fileToUploadfilenya_images"
                                                                placeholder="fileToUpload" style="font-size: smaller;"
                                                                accept="image/*">
                                                            <input type="hidden" class="form-control form-control-sm"
                                                                id="filenya_images" name="filenya_images"
                                                                placeholder="Photos">
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Opsi File
                                                            Foto</label>
                                                        <label v-else>Photo File Options </label>
                                                        <div class="row">
                                                            <div class="col-sm-9">
                                                                <div class="progress">
                                                                    <div class="progress-bar" role="progressbar"
                                                                        aria-valuenow="0" aria-valuemin="0"
                                                                        aria-valuemax="100" style="width:0%"
                                                                        id="persennyafilenya_images">
                                                                        <span id="tulisanpersenfilenya_images">0%</span>
                                                                    </div>
                                                                </div>
                                                                <br>
                                                                <span class="text-success"
                                                                    id="suksesnyafilenya_images"></span>
                                                            </div>
                                                            <div class="col-sm-3 text-center">
                                                                <button type="button"
                                                                    class="btn btn-warning btn-sm lebar text-white"
                                                                    @click="uploadfile('filenya_images', 'image/*')">
                                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                        Upload File
                                                                    </span>
                                                                    <span v-else>Upload Files</span>
                                                                </button>
                                                                <button type="button"
                                                                    class="btn btn-danger btn-sm lebar"
                                                                    @click="clearfilepeta('filenya_images')">
                                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                        Hapus File
                                                                    </span>
                                                                    <span v-else>Delete Files</span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!--IKON PETA 1 END-->
                                                    <!--IKON PETA 2-->
                                                    <div class="col-sm-12">
                                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">2. Lampiran
                                                            (pdf
                                                            files)</label>
                                                        <label v-else>2. Attachments (pdf files)</label>
                                                        <div class="input-group mb-3">
                                                            <div class="input-group-prepend">
                                                                <span class="input-group-text"><i
                                                                        class="far fa-file-pdf"></i></span>
                                                            </div>
                                                            <input type="file" class="form-control form-control-sm"
                                                                id="fileToUploadfilenya_pdf"
                                                                name="fileToUploadfilenya_pdf"
                                                                placeholder="fileToUpload" style="font-size: smaller;"
                                                                accept="application/pdf">
                                                            <input type="hidden" class="form-control form-control-sm"
                                                                id="filenya_pdf" name="filenya_pdf"
                                                                placeholder="Photos">
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Opsi File
                                                            Lampiran</label>
                                                        <label v-else>Attachment File Options </label>
                                                        <div class="row">
                                                            <div class="col-sm-9">
                                                                <div class="progress">
                                                                    <div class="progress-bar" role="progressbar"
                                                                        aria-valuenow="0" aria-valuemin="0"
                                                                        aria-valuemax="100" style="width:0%"
                                                                        id="persennyafilenya_pdf">
                                                                        <span id="tulisanpersenfilenya_pdf">0%</span>
                                                                    </div>
                                                                </div>
                                                                <br>
                                                                <span class="text-success"
                                                                    id="suksesnyafilenya_pdf"></span>
                                                            </div>
                                                            <div class="col-sm-3 text-center">
                                                                <button type="button"
                                                                    class="btn btn-warning btn-sm lebar text-white"
                                                                    @click="uploadfile('filenya_pdf', 'application/pdf')">Upload
                                                                    File</button>
                                                                <button type="button"
                                                                    class="btn btn-danger btn-sm lebar"
                                                                    @click="clearfilepeta('filenya_pdf')">Hapus
                                                                    File</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!--IKON PETA 2 END-->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Kode Keamanan</label>
                                        <label v-else>Captcha</label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i
                                                        class="fas fa-clipboard-list"></i></span>
                                            </div>
                                            <input type="text" class="form-control form-control-sm" id="capchaaduan"
                                                name="capchaaduan" placeholder="Kode Keamanan" v-model="capchaaduan"
                                                disabled>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Ulangi Kode
                                            Keamanan</label>
                                        <label v-else>Repeat Captcha</label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i class="far fa-clone"></i></span>
                                            </div>
                                            <input type="text" class="form-control form-control-sm"
                                                id="capchainputaduan" name="capchainputaduan" placeholder=""
                                                v-model="capchainputaduan" style="text-transform:uppercase">
                                        </div>
                                    </div>

                                    <div class="col-sm-12">&nbsp;</div>
                                </div>
                                <div class="lockscreen-item wow fadeInLeft" style="background: transparent;">
                                    <div class="input-group">
                                        <div class="custom-control custom-switch custom-switch-on-primary">
                                            <input type="checkbox" class="custom-control-input"
                                                id="customSwitchAuthaduan">
                                            <label class="custom-control-label" for="customSwitchAuthaduan"
                                                @click="rubahisiaduan()" style="font-size: small;">
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Autentikasi Pengguna
                                                    Manusia</span>
                                                <span v-else>Human User Authentication</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="help-block text-center">&nbsp;</div>
                                    <button class="form-control btn custom-btn" placeholder="Kirim"
                                        data-toggle="tooltip" data-placement="left" title="Kirim aduan.."
                                        style="color: black;" v-on:click="aduanAct" :disabled="showHumanaduan == false"
                                        v-if="(bahasa === null) || (bahasa == 'ina')">
                                        <b><i class="fas fa-mail-bulk"></i>
                                            Kirim
                                        </b>
                                    </button>
                                    <button class="form-control btn custom-btn" placeholder="Kirim"
                                        data-toggle="tooltip" data-placement="left" title="Kirim aduan.."
                                        style="color: black;" v-on:click="aduanAct" :disabled="showHumanaduan == false"
                                        v-else>
                                        <b><i class="fas fa-mail-bulk"></i>
                                            Send
                                        </b>
                                    </button>
                                </div>
                                <!-- /.lockscreen-item -->
                            </div>
                            <div class="tab-pane fade" id="custom-tabs-four-profile" role="tabpanel"
                                aria-labelledby="custom-tabs-four-profile-tab">
                                <div class="row">
                                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Nama </label>
                                        <label v-else>Name </label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i class="fas fa-user-circle"></i></span>
                                            </div>
                                            <input type="text" class="form-control form-control-sm" id="namainformasi"
                                                name="namainformasi" placeholder="Nama / Name" v-model="namainformasi">
                                        </div>
                                    </div>
                                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Nomor Telepon </label>
                                        <label v-else>Phone number </label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i class="fas fa-phone"></i></span>
                                            </div>
                                            <input type="text" class="form-control form-control-sm" id="nohpinformasi"
                                                name="nohpinformasi" placeholder="Nomor Telepon / Phone number"
                                                v-model="nohpinformasi">
                                        </div>
                                    </div>
                                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Alamat email</label>
                                        <label v-else>Email Address</label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i
                                                        class="far fa-address-card"></i></span>
                                            </div>
                                            <input type="text" class="form-control form-control-sm" id="alamatinformasi"
                                                name="alamatinformasi" placeholder="Alamat email / Email Address"
                                                v-model="alamatinformasi">
                                        </div>
                                    </div>
                                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Judul</label>
                                        <label v-else>Title</label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i
                                                        class="far fa-address-card"></i></span>
                                            </div>
                                            <input type="text" class="form-control form-control-sm" id="judulinformasi"
                                                name="judulinformasi" placeholder="Judul / Title"
                                                v-model="judulinformasi">
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Isi Permintaan Informasi
                                            <small class="text-primary"> (*wajib
                                                diisi)</small></label>
                                        <label v-else>Information Request<small class="text-primary">
                                                (*required)</small></label>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <quill-editor v-model:value="aduaninformasi" :options="modulenya"
                                                    style="height: 25vh;background-color: #ffffff;"></quill-editor>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Kode Keamanan</label>
                                        <label v-else>Captcha</label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i
                                                        class="fas fa-clipboard-list"></i></span>
                                            </div>
                                            <input type="text" class="form-control form-control-sm" id="capchainformasi"
                                                name="capchainformasi" placeholder="Kode Keamanan"
                                                v-model="capchainformasi" disabled>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Ulangi Kode
                                            Keamanan</label>
                                        <label v-else>Repeat Captcha</label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i class="far fa-clone"></i></span>
                                            </div>
                                            <input type="text" class="form-control form-control-sm"
                                                id="capchainputinformasi" name="capchainputinformasi" placeholder=""
                                                v-model="capchainputinformasi" style="text-transform:uppercase">
                                        </div>
                                    </div>

                                    <div class="col-sm-12">&nbsp;</div>
                                </div>
                                <div class="lockscreen-item wow fadeInLeft" style="background: transparent;">
                                    <div class="input-group">
                                        <div class="custom-control custom-switch custom-switch-on-primary">
                                            <input type="checkbox" class="custom-control-input"
                                                id="customSwitchAuthinformasi">
                                            <label class="custom-control-label" for="customSwitchAuthinformasi"
                                                @click="rubahisiinformasi()" style="font-size: small;">
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Autentikasi Pengguna
                                                    Manusia</span>
                                                <span v-else>Human User Authentication</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="help-block text-center">&nbsp;</div>
                                    <button class="form-control btn custom-btn" placeholder="Kirim"
                                        data-toggle="tooltip" data-placement="left" title="Kirim aduan.."
                                        style="color: black;" v-on:click="aduanActinformasi"
                                        :disabled="showHumaninformasi == false"
                                        v-if="(bahasa === null) || (bahasa == 'ina')">
                                        <b><i class="fas fa-mail-bulk"></i>
                                            Kirim
                                        </b>
                                    </button>
                                    <button class="form-control btn custom-btn" placeholder="Kirim"
                                        data-toggle="tooltip" data-placement="left" title="Kirim aduan.."
                                        style="color: black;" v-on:click="aduanActinformasi"
                                        :disabled="showHumaninformasi == false" v-else>
                                        <b><i class="fas fa-mail-bulk"></i>
                                            Send
                                        </b>
                                    </button>
                                </div>
                                <!-- /.lockscreen-item -->
                            </div>
                            <div class="tab-pane fade" id="custom-tabs-four-risk" role="tabpanel"
                                aria-labelledby="custom-tabs-four-risk-tab">
                                <div class="row">
                                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Nama </label>
                                        <label v-else>Name </label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i class="fas fa-user-circle"></i></span>
                                            </div>
                                            <input type="text" class="form-control form-control-sm" id="namamasukan"
                                                name="namamasukan" placeholder="Nama / Name" v-model="namamasukan">
                                        </div>
                                    </div>
                                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Nomor Telepon </label>
                                        <label v-else>Phone number </label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i class="fas fa-phone"></i></span>
                                            </div>
                                            <input type="text" class="form-control form-control-sm" id="nohpmasukan"
                                                name="nohpmasukan" placeholder="Nomor Telepon / Phone number"
                                                v-model="nohpmasukan">
                                        </div>
                                    </div>
                                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Alamat email</label>
                                        <label v-else>Email Address</label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i
                                                        class="far fa-address-card"></i></span>
                                            </div>
                                            <input type="text" class="form-control form-control-sm" id="alamatmasukan"
                                                name="alamatmasukan" placeholder="Alamat email / Email Address"
                                                v-model="alamatmasukan">
                                        </div>
                                    </div>
                                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Judul</label>
                                        <label v-else>Title</label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i
                                                        class="far fa-address-card"></i></span>
                                            </div>
                                            <input type="text" class="form-control form-control-sm" id="judulmasukan"
                                                name="judulmasukan" placeholder="Judul / Title" v-model="judulmasukan">
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Aspirasi / Masukan <small
                                                class="text-primary"> (*wajib
                                                diisi)</small></label>
                                        <label v-else>Aspirations / Input<small class="text-primary">
                                                (*required)</small></label>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <quill-editor v-model:value="aduanmasukan" :options="modulenya"
                                                    style="height: 25vh;background-color: #ffffff;"></quill-editor>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Kode Keamanan</label>
                                        <label v-else>Captcha</label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i
                                                        class="fas fa-clipboard-list"></i></span>
                                            </div>
                                            <input type="text" class="form-control form-control-sm" id="capchamasukan"
                                                name="capchamasukan" placeholder="Kode Keamanan" v-model="capchamasukan"
                                                disabled>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Ulangi Kode
                                            Keamanan</label>
                                        <label v-else>Repeat Captcha</label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i class="far fa-clone"></i></span>
                                            </div>
                                            <input type="text" class="form-control form-control-sm"
                                                id="capchainputmasukan" name="capchainputmasukan" placeholder=""
                                                v-model="capchainputmasukan" style="text-transform:uppercase">
                                        </div>
                                    </div>

                                    <div class="col-sm-12">&nbsp;</div>
                                </div>
                                <div class="lockscreen-item wow fadeInLeft" style="background: transparent;">
                                    <div class="input-group">
                                        <div class="custom-control custom-switch custom-switch-on-primary">
                                            <input type="checkbox" class="custom-control-input"
                                                id="customSwitchAuthmasukan">
                                            <label class="custom-control-label" for="customSwitchAuthmasukan"
                                                @click="rubahisimasukan()" style="font-size: small;">
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Autentikasi Pengguna
                                                    Manusia</span>
                                                <span v-else>Human User Authentication</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="help-block text-center">&nbsp;</div>
                                    <button class="form-control btn custom-btn" placeholder="Kirim"
                                        data-toggle="tooltip" data-placement="left" title="Kirim aduan.."
                                        style="color: black;" v-on:click="aduanActmasukan"
                                        :disabled="showHumanmasukan == false"
                                        v-if="(bahasa === null) || (bahasa == 'ina')">
                                        <b><i class="fas fa-mail-bulk"></i>
                                            Kirim
                                        </b>
                                    </button>
                                    <button class="form-control btn custom-btn" placeholder="Kirim"
                                        data-toggle="tooltip" data-placement="left" title="Kirim aduan.."
                                        style="color: black;" v-on:click="aduanActmasukan"
                                        :disabled="showHumanmasukan == false" v-else>
                                        <b><i class="fas fa-mail-bulk"></i>
                                            Send
                                        </b>
                                    </button>
                                </div>
                                <!-- /.lockscreen-item -->
                            </div>
                        </div>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import { quillEditor } from 'vue3-quill';
import vSelect from 'vue-select';
import CryptoJS from 'crypto-js';
import 'vue3-carousel/dist/carousel.css'
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal, quillEditor, vSelect
    },
    data() {
        return {
            halamanloading: true,
            tabaktif: encodeURIComponent(CryptoJS.AES.encrypt('', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
            datapesan: '',
            datamaster: [],
            tahun: new Date().getFullYear(),
            folder_foto: process.env.VUE_APP_URL_API + 'parastapainnovation_beranda-Gambar?f=',
            project_id: process.env.VUE_APP_PROJECT_ID,
            bahasa: localStorage.getItem("bahasasistem"),
            tahun: new Date().getFullYear(),
            nama: "", nohp: "", alamat: "", aduan: "", judul: "", capchaaduan: this.makeid(5), capchainputaduan: "",
            showHumanaduan: false,
            showPassword: false,

            namainformasi: "", nohpinformasi: "", alamatinformasi: "", aduaninformasi: "", judulinformasi: "", capchainformasi: this.makeid(5), capchainputinformasi: "", showHumaninformasi: false,
            namamasukan: "", nohpmasukan: "", alamatmasukan: "", aduanmasukan: "", judulmasukan: "", capchamasukan: this.makeid(5), capchainputmasukan: "", showHumanmasukan: false,
            datamasteraduan: [],
            masteraduan: [],
            defaultSelectedmasteraduan: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: 0,
            },
            selectedmasteraduan: 0,
            datapesan: '',
            filenya_images: '',
            filenya_pdf: '',
            longitude: '',
            latitude: '',
            sourcenya: '',
            lokasi: [],
            datalokasi: [],
            defaultSelectedlokasi: {
                code: 0,
                label: 'Pilih Lokasi',
                tag: '',
            },
            selectedlokasi: '',

            namaku: '',
            nama_eng: '',
            text_label: '',
            text_label_eng: '',
            keterangan: [],
            keterangan_eng: [],
            folder_slider: process.env.VUE_APP_URL_API + 'parastapainnovation_slider-Gambar?f=',
            foto_background: '',

        };
    },
    methods: {
        rubahisiaduan() {
            if (this.showHumanaduan == false) {
                this.showHumanaduan = true;
            }
            else {
                this.showHumanaduan = false;
            }
        },
        rubahisiinformasi() {
            if (this.showHumaninformasi == false) {
                this.showHumaninformasi = true;
            }
            else {
                this.showHumaninformasi = false;
            }
        },
        rubahisimasukan() {
            if (this.showHumanmasukan == false) {
                this.showHumanmasukan = true;
            }
            else {
                this.showHumanmasukan = false;
            }
        },
        async aduanAct() {
            //alert(this.aduan);
            if ((this.selectedmasteraduan == '') || (this.selectedmasteraduan === null) || (this.selectedmasteraduan === undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih Kategori..',
                });
                document.getElementById('customSwitchAuthaduan').checked = false;
                this.showHumanaduan = false;
                document.getElementById('customSwitchAuthaduan').checked = false;
                return false;
            }
            if ((this.selectedlokasi == '') || (this.selectedlokasi === null) || (this.selectedlokasi === undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih Lokasi..',
                });
                document.getElementById('customSwitchAuthaduan').checked = false;
                this.showHumanaduan = false;
                document.getElementById('customSwitchAuthaduan').checked = false;
                return false;
                return false;
            }
            if (this.nama == "") {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan kolom secara lengkap..',
                });
                document.getElementById('customSwitchAuthaduan').checked = false;
                document.getElementById("nama").focus();
                this.showHumanaduan = false;
                document.getElementById('customSwitchAuthaduan').checked = false;
                return false;
            }
            if (this.judul == "") {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan kolom secara lengkap..',
                });
                document.getElementById('customSwitchAuthaduan').checked = false;
                document.getElementById("judul").focus();
                this.showHumanaduan = false;
                document.getElementById('customSwitchAuthaduan').checked = false;
                return false;
            }
            if (this.aduan == "") {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan kolom secara lengkap..',
                });
                document.getElementById('customSwitchAuthaduan').checked = false;
                //document.getElementById("aduan").focus();
                this.showHumanaduan = false;
                document.getElementById('customSwitchAuthaduan').checked = false;
                return false;
            }
            if (this.capchainputaduan == "") {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan kolom secara lengkap..',
                });
                document.getElementById('customSwitchAuthaduan').checked = false;
                document.getElementById("capchainputaduan").focus();
                this.showHumanaduan = false;
                document.getElementById('customSwitchAuthaduan').checked = false;
                return false;
            }
            if (this.capchainputaduan.toUpperCase() != this.capchaaduan) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Kode Keamanan Tidak Sama..',
                });
                document.getElementById('customSwitchAuthaduan').checked = false;
                document.getElementById("capchainputaduan").focus();
                this.showHumanaduan = false;
                document.getElementById('customSwitchAuthaduan').checked = false;
                return false;
            }
            var tahunregister = this.pad2(new Date().getFullYear());
            var bulanregister = this.pad2(new Date().getMonth() + 1);
            var tanggalregister = this.pad2(new Date().getDate());
            var jamregister = this.pad2(new Date().getHours());
            var menitregister = this.pad2(new Date().getMinutes());
            var detikregister = this.pad2(new Date().getSeconds());

            var koderegistrasi = this.makeid(5) + tahunregister + bulanregister + tanggalregister + jamregister + menitregister + detikregister;
            const data = {
                jenis: this.selectedmasteraduan,
                lokasi: this.selectedlokasi,
                nama: this.nama,
                nohp: this.nohp,
                alamat: this.alamat,
                judul: this.judul,
                aduan: this.aduan,
                project_id: this.project_id,
                filenya_images: document.getElementById('filenya_images').value,
                filenya_pdf: document.getElementById('filenya_pdf').value,
                latitude: document.getElementById('latitude').value,
                longitude: document.getElementById('longitude').value,
                register: koderegistrasi,
            };

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            await mainAPI.post("parastapainnovationMasyarakat-aduan", data).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: Response.data.message,
                        });
                        document.getElementById("nama").focus();
                        this.showHuman = false;
                        document.getElementById('customSwitchAuthaduan').checked = false;
                        return false;

                    }
                    else {
                        swal.fire('Informasi', Response.data.message, 'success').then(function () {

                        });
                        this.nama = '';
                        this.nohp = '';
                        this.alamat = '';
                        this.judul = '';
                        this.aduan = '';
                        this.capchainputaduan = '';
                        this.capchaaduan = this.makeid(5);
                        document.getElementById("nama").focus();
                        this.showHumanaduan = false;
                        document.getElementById('customSwitchAuthaduan').checked = false;
                        return false;
                    }
                }
            ).catch(
                error => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: error,
                    });
                    document.getElementById("nama").focus();
                    document.getElementById('customSwitchAuthaduan').checked = false;
                    this.showHuman = false;
                    return false;
                }
            )
        },
        async aduanActinformasi() {
            //alert(this.aduan);
            if (this.namainformasi == "") {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan kolom secara lengkap..',
                });
                document.getElementById('customSwitchAuthinformasi').checked = false;
                document.getElementById("namainformasi").focus();
                this.showHumaninformasi = false;
                document.getElementById('customSwitchAuthinformasi').checked = false;
                return false;
            }
            if (this.judulinformasi == "") {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan kolom secara lengkap..',
                });
                document.getElementById('customSwitchAuthinformasi').checked = false;
                document.getElementById("judulinformasi").focus();
                this.showHumaninformasi = false;
                document.getElementById('customSwitchAuthinformasi').checked = false;
                return false;
            }
            if (this.aduaninformasi == "") {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan kolom secara lengkap..',
                });
                document.getElementById('customSwitchAuthinformasi').checked = false;
                //document.getElementById("aduan").focus();
                this.showHumaninformasi = false;
                document.getElementById('customSwitchAuthinformasi').checked = false;
                return false;
            }
            if (this.capchainputinformasi == "") {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan kolom secara lengkap..',
                });
                document.getElementById('customSwitchAuthinformasi').checked = false;
                document.getElementById("capchainputinformasi").focus();
                this.showHumaninformasi = false;
                document.getElementById('customSwitchAuthinformasi').checked = false;
                return false;
            }
            if (this.capchainputinformasi.toUpperCase() != this.capchainformasi) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Kode Keamanan Tidak Sama..',
                });
                document.getElementById('customSwitchAuthinformasi').checked = false;
                document.getElementById("capchainputinformasi").focus();
                this.showHumaninformasi = false;
                document.getElementById('customSwitchAuthinformasi').checked = false;
                return false;
            }
            var tahunregister = this.pad2(new Date().getFullYear());
            var bulanregister = this.pad2(new Date().getMonth() + 1);
            var tanggalregister = this.pad2(new Date().getDate());
            var jamregister = this.pad2(new Date().getHours());
            var menitregister = this.pad2(new Date().getMinutes());
            var detikregister = this.pad2(new Date().getSeconds());

            var koderegistrasi = this.makeid(5) + tahunregister + bulanregister + tanggalregister + jamregister + menitregister + detikregister;
            const data = {
                nama: this.namainformasi,
                nohp: this.nohpinformasi,
                alamat: this.alamatinformasi,
                judul: this.judulinformasi,
                aduan: this.aduaninformasi,
                project_id: this.project_id,
                latitude: document.getElementById('latitude').value,
                longitude: document.getElementById('longitude').value,
                register: koderegistrasi,
            };

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            await mainAPI.post("parastapainnovationDataInformasi-datainformasi", data).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: Response.data.message,
                        });
                        document.getElementById("nama").focus();
                        this.showHumaninformasi = false;
                        document.getElementById('customSwitchAuthinformasi').checked = false;
                        return false;

                    }
                    else {
                        swal.fire('Informasi', Response.data.message, 'success').then(function () {

                        });
                        this.namainformasi = '';
                        this.nohpinformasi = '';
                        this.alamatinformasi = '';
                        this.judulinformasi = '';
                        this.aduaninformasi = '';
                        this.capchainputinformasi = '';
                        this.capchainformasi = this.makeid(5);
                        document.getElementById("namainformasi").focus();
                        this.showHumaninformasi = false;
                        document.getElementById('customSwitchAuthinformasi').checked = false;
                        return false;
                    }
                }
            ).catch(
                error => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: error,
                    });
                    document.getElementById("namainformasi").focus();
                    document.getElementById('customSwitchAuthinformasi').checked = false;
                    this.showHuman = false;
                    return false;
                }
            )
        },
        async aduanActmasukan() {
            //alert(this.aduan);
            if (this.namamasukan == "") {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan kolom secara lengkap..',
                });
                document.getElementById('customSwitchAuthmasukan').checked = false;
                document.getElementById("namamasukan").focus();
                this.showHumanmasukan = false;
                document.getElementById('customSwitchAuthmasukan').checked = false;
                return false;
            }
            if (this.judulmasukan == "") {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan kolom secara lengkap..',
                });
                document.getElementById('customSwitchAuthmasukan').checked = false;
                document.getElementById("judulmasukan").focus();
                this.showHumanmasukan = false;
                document.getElementById('customSwitchAuthmasukan').checked = false;
                return false;
            }
            if (this.aduanmasukan == "") {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan kolom secara lengkap..',
                });
                document.getElementById('customSwitchAuthmasukan').checked = false;
                //document.getElementById("aduan").focus();
                this.showHumanmasukan = false;
                document.getElementById('customSwitchAuthmasukan').checked = false;
                return false;
            }
            if (this.capchainputmasukan == "") {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan kolom secara lengkap..',
                });
                document.getElementById('customSwitchAuthmasukan').checked = false;
                document.getElementById("capchainputmasukan").focus();
                this.showHumanmasukan = false;
                document.getElementById('customSwitchAuthmasukan').checked = false;
                return false;
            }
            if (this.capchainputmasukan.toUpperCase() != this.capchamasukan) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Kode Keamanan Tidak Sama..',
                });
                document.getElementById('customSwitchAuthmasukan').checked = false;
                document.getElementById("capchainputmasukan").focus();
                this.showHumanmasukan = false;
                document.getElementById('customSwitchAuthmasukan').checked = false;
                return false;
            }
            var tahunregister = this.pad2(new Date().getFullYear());
            var bulanregister = this.pad2(new Date().getMonth() + 1);
            var tanggalregister = this.pad2(new Date().getDate());
            var jamregister = this.pad2(new Date().getHours());
            var menitregister = this.pad2(new Date().getMinutes());
            var detikregister = this.pad2(new Date().getSeconds());

            var koderegistrasi = this.makeid(5) + tahunregister + bulanregister + tanggalregister + jamregister + menitregister + detikregister;
            const data = {
                nama: this.namamasukan,
                nohp: this.nohpmasukan,
                alamat: this.alamatmasukan,
                judul: this.judulmasukan,
                aduan: this.aduanmasukan,
                project_id: this.project_id,
                latitude: document.getElementById('latitude').value,
                longitude: document.getElementById('longitude').value,
                register: koderegistrasi,
            };

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            await mainAPI.post("parastapainnovationDataMasukan-datamasukan", data).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: Response.data.message,
                        });
                        document.getElementById("namamasukan").focus();
                        this.showHumanmasukan = false;
                        document.getElementById('customSwitchAuthmasukan').checked = false;
                        return false;

                    }
                    else {
                        swal.fire('Informasi', Response.data.message, 'success').then(function () {

                        });
                        this.namamasukan = '';
                        this.nohpmasukan = '';
                        this.alamatmasukan = '';
                        this.judulmasukan = '';
                        this.aduanmasukan = '';
                        this.capchainputmasukan = '';
                        this.capchamasukan = this.makeid(5);
                        document.getElementById("namamasukan").focus();
                        this.showHumanmasukan = false;
                        document.getElementById('customSwitchAuthmasukan').checked = false;
                        return false;
                    }
                }
            ).catch(
                error => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: error,
                    });
                    document.getElementById("nama").focus();
                    document.getElementById('customSwitchAuth').checked = false;
                    this.showHuman = false;
                    return false;
                }
            )
        },
        async ambilmaster() {
            this.halamanloading = true;
            const mainAPI9 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI9.get("parastapainnovationMasyarakat-Master?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datamasteraduan = [];
                        this.masteraduan = [];
                        this.datamasteraduan = Response.data.content.data;

                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.datamasteraduan.forEach((item) => {
                                this.masteraduan.push({
                                    label: item.kategoriMasalahNm,
                                    code: this.datamasteraduan.indexOf(item) + 1,
                                    tag: item.id,
                                });
                            });
                            this.defaultSelectedmasteraduan = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.masteraduan.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.datamasteraduan.forEach((item) => {
                                this.masteraduan.push({
                                    label: item.kategoriMasalahNm_eng,
                                    code: this.datamasteraduan.indexOf(item) + 1,
                                    tag: item.id,
                                });
                            });
                            this.defaultSelectedmasteraduan = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.masteraduan.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }
                    }
                    this.halamanloading = false;
                    this.ambilkoordinat();
                }
            ).catch(error => {
                console.log(error);
                this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI9.get("parastapainnovationreffmonitoring-Lokasi?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datalokasi = [];
                        this.lokasi = [];
                        this.datalokasi = Response.data.content.data;
                        this.datalokasi.forEach((item) => {
                            this.lokasi.push({
                                label: item.nama,
                                code: this.datalokasi.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedlokasi = {
                                code: 0,
                                label: 'Pilih Lokasi',
                                tag: '',
                            };
                            this.lokasi.unshift({
                                label: 'Pilih Lokasi',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedlokasi = {
                                code: 0,
                                label: 'Select Location',
                                tag: '',
                            };
                            this.lokasi.unshift({
                                label: 'Select Location',
                                code: 0,
                                tag: '',
                            });
                        }
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            const mainAPI3 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });

            this.halamanloading = true;
            var random = Math.random();
            await mainAPI3.get("parastapainnovation-GetSlider?random=" + random + "&project_id=" + this.project_id + "&id=7").then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.dataslider = [];
                        this.dataslider = Response.data.content.data;
                        this.namaku = Response.data.content.data[0].nama;
                        this.nama_eng = Response.data.content.data[0].nama_eng;
                        this.text_label = Response.data.content.data[0].text_label;
                        this.text_label_eng = Response.data.content.data[0].text_label_eng;
                        this.keterangan = Response.data.content.data[0].keterangan;
                        this.keterangan_eng = Response.data.content.data[0].keterangan_eng;
                        this.foto_background = '';
                        this.foto_background = Response.data.content.data[0].filenya_slider;
                        this.halamanloading = false;
                    }
                    else {
                        this.dataslider = [];
                        this.foto_background = '';
                        this.halamanloading = false;
                    }
                }
            ).catch(error => {
                this.datapesan = '';
                this.foto_background = '';
                this.dataslider = [];
                this.halamanloading = false;
            });
        },
        onlokasiChange(a) {
            try {
                this.selectedlokasi = this.lokasi[a].tag;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedlokasi);
        },
        ambilkoordinat() {
            if (navigator.geolocation) {
                const successCallback = (position) => {
                    this.latitude = position.coords.latitude;
                    this.longitude = position.coords.longitude;
                };
                const errorCallback = (error) => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: error,
                    });
                    return false;
                };

                navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
            }
            else {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Aktifkan GPS / Lokasi Gadget / Permission Location..',
                });
                return false;
            }
        },
        toggleShow() {
            this.showPassword = !this.showPassword;
        },
        onmasteraduanChange(a) {
            try {
                this.selectedmasteraduan = this.masteraduan[a].tag;
            }
            catch (err) {
                return;
            }
        },
        uploadfile(idnya, tipenya) {
            var elmnt = document.getElementById("fileToUpload" + idnya);
            try {
                var namanya = elmnt.files[0].name;
                //alert(elmnt.files[0]['type'].toUpperCase());
                if (tipenya == 'image/*') {
                    if ((elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPEG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/PNG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/GIF')) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format gambar';
                        return;
                    }
                }
                else {
                    if (elmnt.files[0]['type'] != tipenya) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format pdf';
                        return;
                    }
                }
            } catch (error) {
                document.getElementById('suksesnya' + idnya).innerHTML = '*pilih file terlebih dahulu';
                return;
            }
            var fd = new FormData();
            fd.append("fileToUpload", elmnt.files[0], elmnt.files[0].name);
            fd.append("project_id", this.project_id);
            fd.append("folderToUpload", idnya);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationpeta-FilesUpload", fd, {
                onUploadProgress: function (uploadEvent) {
                    document.getElementById('persennya' + idnya).style.width = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                    document.getElementById('tulisanpersen' + idnya).innerHTML = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                }
            }).then(
                function (res) {
                    document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                    if (res.data.filename != undefined) {
                        document.getElementById(idnya).value = res.data.filename;
                    }
                }
            ).catch(function (e) {
                document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                document.getElementById(idnya).value = '';
                console.log(e);
            }
            )
        },
        clearfilepeta(idnya) {
            if (document.getElementById(idnya).value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'File Tidak Tersedia',
                });
                return false;
            }

            var fd = new FormData();
            fd.append("folderToUpload", idnya);
            fd.append("filenya", document.getElementById(idnya).value);
            fd.append("project_id", this.project_id);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationpeta-FilesDeleted", fd).then(
                Response => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: Response.data.message,
                    });
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )

            document.getElementById('fileToUpload' + idnya).value = '';
            document.getElementById(idnya).value = '';
            document.getElementById('persennya' + idnya).style.width = "0%";
            document.getElementById('tulisanpersen' + idnya).innerHTML = "0%";
            document.getElementById('suksesnya' + idnya).innerHTML = '';
            return false;
        },

    },
    mounted() {
        this.ambilmaster();
    },
}
</script>

<style>
.carousel__prev,
.carousel__next {
    box-sizing: content-box;
    border: 5px solid #0055aa;
    border-radius: 40px;
    background-color: #0055aa;
    color: aliceblue;
    height: 50px;
    width: 50px;
}

/* The Modal (background) */
.modal {
    display: none;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 888888;
    /* Sit on top */
    padding-top: 20px;
    /* Location of the box */
    left: 0;
    top: 0;
    width: 100%;
    /* Full width */
    height: 100%;
    /* Full height */
    overflow: auto;
    /* Enable scroll if needed */
    background-color: rgb(251, 248, 248, 0.9);
    /* Fallback color */
    background-color: rgb(251, 248, 248, 0.9);
    /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
    float: left;
    margin-right: 10px;
    margin-left: 60px;
}

/* Caption of Modal Image */
#caption {
    margin: auto;
    display: block;
    width: 90%;
    max-width: 90%;
    text-align: justify;
    color: #111;
    padding: 10px 0;
}

/* Add Animation */
.modal-content,
#caption {
    -webkit-animation-name: zoom;
    -webkit-animation-duration: 0.6s;
    animation-name: zoom;
    animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
    from {
        -webkit-transform: scale(0)
    }

    to {
        -webkit-transform: scale(1)
    }
}

@keyframes zoom {
    from {
        transform: scale(0)
    }

    to {
        transform: scale(1)
    }
}

/* The Close Button */
.close {
    position: absolute;
    top: 20px;
    right: 35px;
    color: #111;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
    z-index: 99999;
}

.close:hover,
.close:focus {
    color: #111;
    text-decoration: none;
    cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
    .modal-content {
        width: 100%;
    }
}

.gambar:hover {
    cursor: pointer;
    opacity: 0.5;
}
</style>